// --------------------------------------------------------------
// Created On: 2021-05-14
// Author: Zachary Thomas
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./Error.module.scss";

// Error message.
export default function Error(props: Props): Component {
  return props.message.length > 0 ? (
    <div className={`${styles.text} alert alert-danger`} role="alert">
      {props.message}
    </div>
  ) : null;
}

interface Props {
  message: string;
}
